module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cc-Db-Ee.e2ca9049.png";